// ROUTES
import { ROUTE_SGU, ROUTE_POUPATEMPO } from 'routes/paths';

// RELATÓRIOS
export const ROUTE_SGU_RELATORIO_USUARIO_POR_LOCALIDADE = `${ROUTE_POUPATEMPO}${ROUTE_SGU}/relatorio/usuario-por-localidade`;
export const ROUTE_SGU_RELATORIO_ESTATISTICA = `${ROUTE_POUPATEMPO}${ROUTE_SGU}/relatorio/estatistica`;
export const ROUTE_SGU_RELATORIO_QUEIMA_DARE = `${ROUTE_POUPATEMPO}${ROUTE_SGU}/relatorio/queima-dare`;
export const ROUTE_SGU_RELATORIO_SITUACAO_DARE = `${ROUTE_POUPATEMPO}${ROUTE_SGU}/relatorio/situacao-dare`;
export const ROUTE_SGU_RELATORIO_RELATORIO_MENSAL_DARE = `${ROUTE_POUPATEMPO}${ROUTE_SGU}/relatorio/relatorio-mensal-dare`;
